import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Col, Row} from "reactstrap";
import Subtitle from "./Subtitle";

class InfoBlocks extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <Row>
            <Col xs={6}>
                <p style={{marginBottom:"0"}}>{i18n.t(this.props.leftTitleResource, this.props)}</p>
                <Subtitle textResource={i18n.t(this.props.leftTextResource, this.props)} />
            </Col>
            <Col xs={6}>
                <p style={{marginBottom:"0"}}>{i18n.t(this.props.rightTitleResource, this.props)}</p>
                <Subtitle textResource={i18n.t(this.props.rightTextResource, this.props)} />
            </Col>
        </Row>
    }
}

export default translate("translations")(InfoBlocks);